import { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer">
          <div className="container">
            <span className="text-muted">Copyright © 2022 Rakibul Hasan, All rights reserved.</span>
          </div>
        </footer>
      </div>
    );
  }
}
